import React from 'react';

const BillDeskPaymentView = props => {
  return <></>;
};

export default React.memo(BillDeskPaymentView);
